module.exports = __webpack_public_path__ + "img/54000.2e0989f1.jpg";